import { Exclude, Type } from "class-transformer";
import { FileModel } from "./FileModel";
import { YSNO, YSNONA } from "./PPR";

export class FinancialOverviewRow {
    actual_expenditure!: number;
    cost_budgeted?: number;
    budget_fkid?: number;
    cost_expenditure!: number;
    id_line_item!: number;
    type_description!: string;
    remarks?: string;
    component?: string;
    ds_attivita?: string;
    ds_proposta?: string;
    upload_urls: string[] = [];
    file_ids: number[] = [];
    max_files_upload?: number;

    @Exclude()
    get isValid(): string | null {
        if (typeof this.actual_expenditure !== "number") {
            return !this.remarks ? "remarks" : null;
        }
        if (this.actual_expenditure >= 0) {
            return this.actual_expenditure === 0 ? (!this.remarks ? "remarks" : null) : null;
        } else {
            return "remarks";
        }
    }
}

class FinancialOverviewTotals {}

export class FinancialOverviewResponse {
    @Type(() => FinancialOverviewRow)
    rows!: FinancialOverviewRow[];
    @Type(() => FinancialOverviewTotals)
    totals!: FinancialOverviewTotals;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        for (const i in this.rows) {
            const isValid = this.rows[i].isValid;
            if (typeof isValid === "string") {
                errors.push(`${isValid}_${i}`);
            }
        }
        return errors;
    }
}

export class FinancialOverviewM6P1Row extends FileModel {
    type_description!: string | null;
    cost_expenditure!: number | null;
    actual_expenditure!: number | null;
    remarks?: string;

    @Exclude()
    get isValid(): string | null {
        if (typeof this.actual_expenditure !== "number") {
            return !this.remarks ? "remarks" : null;
        } else if (typeof this.actual_expenditure === "number" && this.actual_expenditure >= 0) {
            return this.actual_expenditure === 0 ? (!this.remarks ? "remarks" : null) : null;
        } else {
            return "remarks";
        }
    }

    @Exclude()
    get isEmpty() {
        return (
            typeof this.actual_expenditure !== "number" &&
            !this.type_description &&
            typeof this.cost_expenditure !== "number" &&
            !this.remarks
        );
    }
}

class FinancialOverviewM6P1Totals {}

export class FinancialOverviewResponseM6P1 {
    @Type(() => FinancialOverviewM6P1Row)
    rows!: FinancialOverviewM6P1Row[];
    @Type(() => FinancialOverviewM6P1Totals)
    totals!: FinancialOverviewM6P1Totals;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        for (const i in this.rows) {
            const isValid = this.rows[i].isValid;
            if (typeof isValid === "string") {
                errors.push(`${isValid}_${i}`);
            }
        }
        return errors;
    }
}

export class Disclaimer {
    pcr_disclaimer_09!: YSNO | null;

    @Exclude()
    isValid(): string[] {
        const errors: string[] = [];
        !this.pcr_disclaimer_09 && errors.push("pcr_disclaimer_09");
        return errors;
    }
}

export class ProjectImplementation extends FileModel {
    pcr_proj_impl_01_1!: string | null; //     |    Textarea       |                |   A. Description of project (Obligatory)
    // pcr_proj_impl_01_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_03_1!: string | null;    //     |    Description    |                |   C. Other Indicators - Tangible benefits generated by the EAFRD - funded actions (Obligatory)
    pcr_proj_impl_03_2!: string | null; //     |    Textarea       |                |   i. Number of jobs created as a result of the project. Please indicate whether Full-time (FTE - equivalent of 8 working hours per day) or Part-time (number of working hours per day to be specified) (where applicable).
    pcr_proj_impl_03_3!: string | null; //     |    Textarea       |                |   ii. List any other results which were NOT anticipated in the Grant Agreement.
    // pcr_proj_impl_03_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_04_1!: string | null;    //     |    Description    |                |   D. Other Indicators - Intangible benefits generated by the EAFRD - funded actions (Obligatory)
    pcr_proj_impl_04_2!: string | null; //     |    Textarea       |                |   i. Has the project's implementation contributed directly to the diversification of the organisation's economic activities towards non-agricultural activities ? If yes, please specify the type of activity/ies.
    pcr_proj_impl_04_3!: string | null; //     |    Textarea       |                |   ii. Has the project's implementation contributed directly to the diversification of the organisation's economic activities towards new agricultural activities ? If yes, please specify the type of new agricultural activity/ies.
    // pcr_proj_impl_04_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_05_1!: string | null;    //     |    Description    |                |   E. How has the project benefitted the environment (ex. Climate change) ? Kindly tick accordingly. (Obligatory)
    pcr_proj_impl_05_2!: YSNONA | null; //     |    Check          |                |   Reduced Greenhouse gas emissions through a reduction in electricity consumption.
    pcr_proj_impl_05_3!: YSNONA | null; //     |    Check          |                |   Reduced impacts on groundwater through the provision of alternative water and / or through increased water storage.
    //! DUPLICATE pcr_proj_impl_05_4!: YSNONA | null;       //     |    Check          |                |   Reduced impacts on groundwater through the provision of alternative water and / or through increased water storage.
    pcr_proj_impl_05_5!: YSNONA | null; //     |    Check          |                |   Improved water efficiency.
    pcr_proj_impl_05_6!: YSNONA | null; //     |    Check          |                |   Impacts on biodiversity and groundwater from reduced application of chemicals.
    pcr_proj_impl_05_7!: YSNONA | null; //     |    Check          |                |   Impacts on biodiversity through use of bee boxes.
    pcr_proj_impl_05_8!: YSNONA | null; //     |    Check          |                |   Impacts on biodiversity through construction / maintenance of traditional rubble walls.
    pcr_proj_impl_05_9!: YSNONA | null; //     |    Check          |                |   Impacts on biodiversity through investment in green infrastructure / landscaping / tree planting / ecological restoration / ecological rehabilitation.
    pcr_proj_impl_05_10!: YSNONA | null; //     |    Check          |                |   Impacts on biodiversity and groundwater from organic farming / integrated pest management
    pcr_proj_impl_05_11!: YSNONA | null; //     |    Check          |                |   Reduction in waste generation through increased reuse.
    pcr_proj_impl_05_12!: YSNONA | null; //     |    Check          |                |   Impacts on soil through better soil management.
    pcr_proj_impl_05_13!: string | null; //     |    Textarea       |                |   Other - kindly indicate
    // pcr_proj_impl_05_b!: string | null;    //     |    Description    |                |
    pcr_proj_impl_06_1!: string | null; //     |    Textarea       |                |   F. Have you participated in any training or information events relevant to your activity within the last two years ? If yes, kindly provide additional details. (Obligatory)
    // pcr_proj_impl_06_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_07_1!: string | null;    //     |    Description    |                |   G. Dissemination of results (Obligatory)
    pcr_proj_impl_07_2!: YSNONA | null; //     |    Combo          |     NO-YES     |   Have you carried out measures assuring dissemination of the project's results ?
    pcr_proj_impl_07_3!: string | null; //     |    Textarea       |                |   If yes, please give a detailed description of measures undertaken to disseminate the results of the project, including all the documents, leaflets, booklets, websites, press releases, and other visibility tools that publicised the Fund.
    pcr_proj_impl_07_4!: string | null; //     |    Textarea       |                |   Please attach all the publicity and visibility material you have in hand in relation to the project.
    pcr_proj_impl_07_5!: string | null; //     |    Textarea       |                |   Kindly also submit photos relating to the implemented project, including a photo of every line item mentioned in part 1(B) (Obligatory)
    // pcr_proj_impl_07_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_08_1!: string | null;    //     |    Description    |                |   H. Difficulties, Risks and Threats (Obligatory)
    // pcr_proj_impl_08_2!: string | null;    //     |    Description    |                |   Indicate any difficulties you may have encountered during the implementation of the project and how there were addressed.
    pcr_proj_impl_08_3!: YSNONA | null; //     |    Combo          |     NO-YES     |   Difficulty in finding skilled workers / contractors to do the work
    pcr_proj_impl_08_4!: string | null; //     |    Textarea       |                |   If yes, specify Actions undertaken
    pcr_proj_impl_08_5!: YSNONA | null; //     |    Combo          |     NO-YES     |   Difficulty in obtaining necessary number of quotes
    pcr_proj_impl_08_6!: string | null; //     |    Textarea       |                |   If yes, specify Actions undertaken
    pcr_proj_impl_08_7!: YSNONA | null; //     |    Combo          |     NO-YES     |   Lengthy permitting process (Planning Authority, Environment Resources Authority, Energy & Water Agency, etc)
    pcr_proj_impl_08_8!: string | null; //     |    Textarea       |                |   If yes, specify Actions undertaken
    pcr_proj_impl_08_9!: YSNONA | null; //     |    Combo          |     NO-YES     |   Difficulty in finding necessary expertise
    pcr_proj_impl_08_10!: string | null; //     |    Textarea       |                |   If yes, specify Actions undertaken
    pcr_proj_impl_08_11!: YSNONA | null; //     |    Combo          |     NO-YES     |   Higher costs than anticipated
    pcr_proj_impl_08_12!: string | null; //     |    Textarea       |                |   If yes, specify Actions undertaken
    pcr_proj_impl_08_13!: YSNONA | null; //     |    Combo          |     NO-YES     |   Long procurement process (For Public Entities)
    pcr_proj_impl_08_14!: string | null; //     |    Textarea       |                |   If yes, specify Actions undertaken
    pcr_proj_impl_08_15!: string | null; //     |    Textarea       |                |   Other
    // pcr_proj_impl_08_b!: string | null;    //     |    Description    |                |
    pcr_proj_impl_09_1!: string | null; //     |    Textarea       |                |   I. Are there any recommendations and observations in order to facilitate smoother implementation for similar project implementation ? (Obligatory)
    // pcr_proj_impl_09_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_10_1!: string | null;    //     |    Description    |                |   J. Project sustainabality (Obligatory)
    pcr_proj_impl_10_2!: string | null; //     |    Textarea       |                |   Describe how the benefits of the project will continue to be ensured after the project completion, particularly in terms of climate change and environment.
    // pcr_proj_impl_10_b!: string | null;    //     |    Description    |                |
    // pcr_proj_impl_11_1!: string | null;    //     |    Description    |                |   K. Innovation (Obligatory)
    pcr_proj_impl_11_2!: YSNONA | null; //     |    Combo          |     NO-YES     |   Does this project include an innovative component ?
    pcr_proj_impl_11_3!: string | null; //     |    Textarea       |                |   If Yes, please specify:

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        !this.pcr_proj_impl_01_1 && errors.push("pcr_proj_impl_01_1");

        !this.pcr_proj_impl_03_2 && errors.push("pcr_proj_impl_03_2");
        !this.pcr_proj_impl_03_3 && errors.push("pcr_proj_impl_03_3");

        !this.pcr_proj_impl_04_2 && errors.push("pcr_proj_impl_04_2");
        !this.pcr_proj_impl_04_3 && errors.push("pcr_proj_impl_04_3");

        !this.pcr_proj_impl_05_2 && errors.push("pcr_proj_impl_05_2");
        !this.pcr_proj_impl_05_3 && errors.push("pcr_proj_impl_05_3");
        // !this.pcr_proj_impl_05_4 && errors.push("pcr_proj_impl_05_4");
        !this.pcr_proj_impl_05_5 && errors.push("pcr_proj_impl_05_5");
        !this.pcr_proj_impl_05_6 && errors.push("pcr_proj_impl_05_6");
        !this.pcr_proj_impl_05_7 && errors.push("pcr_proj_impl_05_7");
        !this.pcr_proj_impl_05_8 && errors.push("pcr_proj_impl_05_8");
        !this.pcr_proj_impl_05_9 && errors.push("pcr_proj_impl_05_9");
        !this.pcr_proj_impl_05_10 && errors.push("pcr_proj_impl_05_10");
        !this.pcr_proj_impl_05_11 && errors.push("pcr_proj_impl_05_11");
        !this.pcr_proj_impl_05_12 && errors.push("pcr_proj_impl_05_12");
        !this.pcr_proj_impl_05_13 && errors.push("pcr_proj_impl_05_13");

        !this.pcr_proj_impl_06_1 && errors.push("pcr_proj_impl_06_1");

        !this.pcr_proj_impl_07_2 && errors.push("pcr_proj_impl_07_2");
        const pcr_proj_impl_07_3_valid = this.pcr_proj_impl_07_2 === "000001" ? !!this.pcr_proj_impl_07_3 : true;
        !pcr_proj_impl_07_3_valid && errors.push("pcr_proj_impl_07_3");

        !this.pcr_proj_impl_07_4 && errors.push("pcr_proj_impl_07_4");
        !this.pcr_proj_impl_07_5 && errors.push("pcr_proj_impl_07_5");

        !this.pcr_proj_impl_08_3 && errors.push("pcr_proj_impl_08_3");
        const pcr_proj_impl_08_4_valid = this.pcr_proj_impl_08_3 === "000001" ? !!this.pcr_proj_impl_08_4 : true;
        !pcr_proj_impl_08_4_valid && errors.push("pcr_proj_impl_08_4");
        !this.pcr_proj_impl_08_5 && errors.push("pcr_proj_impl_08_5");
        const pcr_proj_impl_08_6_valid = this.pcr_proj_impl_08_5 === "000001" ? !!this.pcr_proj_impl_08_6 : true;
        !pcr_proj_impl_08_6_valid && errors.push("pcr_proj_impl_08_6");
        !this.pcr_proj_impl_08_7 && errors.push("pcr_proj_impl_08_7");
        const pcr_proj_impl_08_8_valid = this.pcr_proj_impl_08_7 === "000001" ? !!this.pcr_proj_impl_08_8 : true;
        !pcr_proj_impl_08_8_valid && errors.push("pcr_proj_impl_08_8");
        !this.pcr_proj_impl_08_9 && errors.push("pcr_proj_impl_08_9");
        const pcr_proj_impl_08_10_valid = this.pcr_proj_impl_08_9 === "000001" ? !!this.pcr_proj_impl_08_10 : true;
        !pcr_proj_impl_08_10_valid && errors.push("pcr_proj_impl_08_10");
        !this.pcr_proj_impl_08_11 && errors.push("pcr_proj_impl_08_11");
        const pcr_proj_impl_08_12_valid = this.pcr_proj_impl_08_11 === "000001" ? !!this.pcr_proj_impl_08_12 : true;
        !pcr_proj_impl_08_12_valid && errors.push("pcr_proj_impl_08_12");
        !this.pcr_proj_impl_08_13 && errors.push("pcr_proj_impl_08_13");
        const pcr_proj_impl_08_14_valid = this.pcr_proj_impl_08_13 === "000001" ? !!this.pcr_proj_impl_08_14 : true;
        !pcr_proj_impl_08_14_valid && errors.push("pcr_proj_impl_08_14");
        !this.pcr_proj_impl_08_15 && errors.push("pcr_proj_impl_08_15");

        !this.pcr_proj_impl_09_1 && errors.push("pcr_proj_impl_09_1");

        !this.pcr_proj_impl_10_2 && errors.push("pcr_proj_impl_10_2");

        !this.pcr_proj_impl_11_2 && errors.push("pcr_proj_impl_11_2");
        const pcr_proj_impl_11_3_valid = this.pcr_proj_impl_11_2 === "000001" ? !!this.pcr_proj_impl_11_3 : true;
        !pcr_proj_impl_11_3_valid && errors.push("pcr_proj_impl_11_3");

        return errors;
    }
}

export class KeyIndicatorsM4P1 {
    pcr_41_indic_03!: YSNONA | null;
    pcr_41_indic_04!: string | null;
    pcr_41_indic_05!: YSNONA | null;
    pcr_41_indic_06!: string | null;
    pcr_41_indic_07!: YSNONA | null;
    pcr_41_indic_08!: string | null;
    pcr_41_indic_09!: YSNONA | null;
    pcr_41_indic_10!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        !this.pcr_41_indic_03 && errors.push("pcr_41_indic_03");
        const pcr_41_indic_04_valid = this.pcr_41_indic_03 === "000001" ? !!this.pcr_41_indic_04 : true;
        !pcr_41_indic_04_valid && errors.push("pcr_41_indic_04");

        !this.pcr_41_indic_05 && errors.push("pcr_41_indic_05");
        const pcr_41_indic_06_valid = this.pcr_41_indic_05 === "000001" ? !!this.pcr_41_indic_06 : true;
        !pcr_41_indic_06_valid && errors.push("pcr_41_indic_06");

        !this.pcr_41_indic_07 && errors.push("pcr_41_indic_07");
        const pcr_41_indic_08_valid = this.pcr_41_indic_07 === "000001" ? !!this.pcr_41_indic_08 : true;
        !pcr_41_indic_08_valid && errors.push("pcr_41_indic_08");

        !this.pcr_41_indic_09 && errors.push("pcr_41_indic_09");
        const pcr_41_indic_10_valid = this.pcr_41_indic_09 === "000001" ? !!this.pcr_41_indic_10 : true;
        !pcr_41_indic_10_valid && errors.push("pcr_41_indic_10");

        return errors;
    }
}

export class KeyIndicatorsM4P3Road {
    ds_road!: string | null;
    fg_apply!: "S" | "N" | null;
    measurements!: number | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        typeof this.measurements !== "number" && errors.push("measurements");
        return errors;
    }

    @Exclude()
    get isEmpty() {
        return typeof this.measurements !== "number" && !this.ds_road;
    }
}

export class KeyIndicatorsM4P3Water {
    pcr_43w_indic_03!: YSNONA | null;
    pcr_43w_indic_04!: string | null;
    pcr_43w_indic_05!: YSNONA | null;
    pcr_43w_indic_06!: string | null;
    pcr_43w_indic_07!: YSNONA | null;
    pcr_43w_indic_08!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        !this.pcr_43w_indic_03 && errors.push("pcr_43w_indic_03");
        const pcr_43w_indic_04_valid = this.pcr_43w_indic_03 === "000001" ? !!this.pcr_43w_indic_04 : true;
        !pcr_43w_indic_04_valid && errors.push("pcr_43w_indic_04");

        !this.pcr_43w_indic_05 && errors.push("pcr_43w_indic_05");
        const pcr_43w_indic_06_valid = this.pcr_43w_indic_05 === "000001" ? !!this.pcr_43w_indic_06 : true;
        !pcr_43w_indic_06_valid && errors.push("pcr_43w_indic_06");

        !this.pcr_43w_indic_07 && errors.push("pcr_43w_indic_07");
        const pcr_43w_indic_08_valid = this.pcr_43w_indic_07 === "000001" ? !!this.pcr_43w_indic_08 : true;
        !pcr_43w_indic_08_valid && errors.push("pcr_43w_indic_08");

        return errors;
    }
}

export class KeyIndicatorsM4P4 {
    pcr_44_indic_03!: YSNONA | null;
    pcr_44_indic_04!: string | null;
    pcr_44_indic_05!: YSNONA | null;
    pcr_44_indic_06!: string | null;
    pcr_44_indic_07!: YSNONA | null;
    pcr_44_indic_08!: string | null;
    pcr_44_indic_09!: YSNONA | null;
    pcr_44_indic_10!: string | null;
    pcr_44_indic_11!: YSNONA | null;
    pcr_44_indic_12!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        !this.pcr_44_indic_03 && errors.push("pcr_44_indic_03");
        const pcr_44_indic_04_valid = this.pcr_44_indic_03 === "000001" ? !!this.pcr_44_indic_04 : true;
        !pcr_44_indic_04_valid && errors.push("pcr_44_indic_04");

        !this.pcr_44_indic_05 && errors.push("pcr_44_indic_05");
        const pcr_44_indic_06_valid = this.pcr_44_indic_05 === "000001" ? !!this.pcr_44_indic_06 : true;
        !pcr_44_indic_06_valid && errors.push("pcr_44_indic_06");

        !this.pcr_44_indic_07 && errors.push("pcr_44_indic_07");
        const pcr_44_indic_08_valid = this.pcr_44_indic_07 === "000001" ? !!this.pcr_44_indic_08 : true;
        !pcr_44_indic_08_valid && errors.push("pcr_44_indic_08");

        !this.pcr_44_indic_09 && errors.push("pcr_44_indic_09");
        const pcr_44_indic_10_valid = this.pcr_44_indic_09 === "000001" ? !!this.pcr_44_indic_10 : true;
        !pcr_44_indic_10_valid && errors.push("pcr_44_indic_10");

        !this.pcr_44_indic_11 && errors.push("pcr_44_indic_11");
        const pcr_44_indic_12_valid = this.pcr_44_indic_11 === "000001" ? !!this.pcr_44_indic_12 : true;
        !pcr_44_indic_12_valid && errors.push("pcr_44_indic_12");

        return errors;
    }
}

export class KeyIndicatorsM6P1 {
    pcr_61_indic_03!: YSNONA | null;
    pcr_61_indic_04!: string | null;
    pcr_61_indic_05!: YSNONA | null;
    pcr_61_indic_06!: string | null;
    pcr_61_indic_07!: YSNONA | null;
    pcr_61_indic_08!: string | null;
    pcr_61_indic_09!: YSNONA | null;
    pcr_61_indic_10!: string | null;
    pcr_61_indic_11!: YSNONA | null;
    pcr_61_indic_12!: string | null;
    pcr_61_indic_13!: YSNONA | null;
    pcr_61_indic_14!: string | null;
    pcr_61_indic_15!: YSNONA | null;
    pcr_61_indic_16!: string | null;
    pcr_61_indic_17!: YSNONA | null;
    pcr_61_indic_18!: string | null;
    pcr_61_indic_19!: YSNONA | null;
    pcr_61_indic_20!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];

        !this.pcr_61_indic_03 && errors.push("pcr_61_indic_03");
        const pcr_61_indic_04_valid = this.pcr_61_indic_03 === "000001" ? !!this.pcr_61_indic_04 : true;
        !pcr_61_indic_04_valid && errors.push("pcr_61_indic_04");

        !this.pcr_61_indic_05 && errors.push("pcr_61_indic_05");
        const pcr_61_indic_06_valid = this.pcr_61_indic_05 === "000001" ? !!this.pcr_61_indic_06 : true;
        !pcr_61_indic_06_valid && errors.push("pcr_61_indic_06");

        !this.pcr_61_indic_07 && errors.push("pcr_61_indic_07");
        const pcr_61_indic_08_valid = this.pcr_61_indic_07 === "000001" ? !!this.pcr_61_indic_08 : true;
        !pcr_61_indic_08_valid && errors.push("pcr_61_indic_08");

        !this.pcr_61_indic_09 && errors.push("pcr_61_indic_09");
        const pcr_61_indic_10_valid = this.pcr_61_indic_09 === "000001" ? !!this.pcr_61_indic_10 : true;
        !pcr_61_indic_10_valid && errors.push("pcr_61_indic_10");

        !this.pcr_61_indic_11 && errors.push("pcr_61_indic_11");
        const pcr_61_indic_12_valid = this.pcr_61_indic_11 === "000001" ? !!this.pcr_61_indic_12 : true;
        !pcr_61_indic_12_valid && errors.push("pcr_61_indic_12");

        !this.pcr_61_indic_13 && errors.push("pcr_61_indic_13");
        const pcr_61_indic_14_valid = this.pcr_61_indic_13 === "000001" ? !!this.pcr_61_indic_14 : true;
        !pcr_61_indic_14_valid && errors.push("pcr_61_indic_14");

        !this.pcr_61_indic_15 && errors.push("pcr_61_indic_15");
        const pcr_61_indic_16_valid = this.pcr_61_indic_15 === "000001" ? !!this.pcr_61_indic_16 : true;
        !pcr_61_indic_16_valid && errors.push("pcr_61_indic_16");

        !this.pcr_61_indic_17 && errors.push("pcr_61_indic_17");
        const pcr_61_indic_18_valid = this.pcr_61_indic_17 === "000001" ? !!this.pcr_61_indic_18 : true;
        !pcr_61_indic_18_valid && errors.push("pcr_61_indic_18");

        !this.pcr_61_indic_19 && errors.push("pcr_61_indic_19");
        const pcr_61_indic_20_valid = this.pcr_61_indic_19 === "000001" ? !!this.pcr_61_indic_20 : true;
        !pcr_61_indic_20_valid && errors.push("pcr_61_indic_20");

        return errors;
    }
}

export class BestPractices {
    pcr_best_practice_1_1!: string | null;
    pcr_best_practice_2_1!: string | null;

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        !this.pcr_best_practice_1_1 && errors.push("pcr_best_practice_1_1");
        !this.pcr_best_practice_2_1 && errors.push("pcr_best_practice_2_1");
        return errors;
    }
}
